import { QUERY_GET_FACTORY_RENT_TYPES } from '../../fetch/constantQueries'
import { baseThunk } from '../../fetch/basicThunk';

export const getFactoryRentTypes = baseThunk(`factoryRentTypes/getRentTypes`, QUERY_GET_FACTORY_RENT_TYPES, "GET")
